export enum TicketTypeEn {
  New = 1,
  Issue = 2
}
